import React, { Component } from "react";
import { directoryService } from '../services/directory';

import '../assets/styles/Directory.scss';
import _ from 'lodash';

import Spinner from 'react-bootstrap/Spinner';
import SEO from './SEO';

class Specialties extends Component {

    constructor(props){
        super(props);

        this.state = {
            loading: false,
            directories: [],
            filtered_directories: [],
            filters: global.constant.directory_filters,
            metadata: {
                title: 'Find Healthcare Professionals By Specialty',
                description: 'Find healthcare professionals available by specialty at BookDoc. View available time slots and book appointments instantly!',
                type: 'website'
            }
        }
    }

    getSpecialties(){
        this.setState({
            loading: true
        });

        directoryService.specialties()
        .then(
            data => {
                if(data){
                    this.setState({
                        directories: data,
                        filtered_directories: data
                    });
                }
            },
            error => {
                console.log(error)
                this.setState({ error })
            }
        ).then(() => {
            this.setState({
                loading: false
            });
        });
    }

    componentDidMount(){
        this.getSpecialties();
    }

    filterBy(value){
        if(value === 'All'){
            this.setState({
                filtered_directories: this.state.directories
            });
        }else{
            this.setState({
                filtered_directories: _.filter(this.state.directories, function(o) {
                    return _.startsWith(_.upperCase(o.name), value);
                })
            });
        }
    }

    render() {
        return (
            <>
            <SEO 
            title={this.state.metadata.title} 
            description={this.state.metadata.description}
            type={this.state.metadata.type} />
            <div className="directory-page container">
                <div className="header">
                    <h1 className="title">Find By Healthcare Professionals</h1>
                </div>
                <hr className="header-line"/>
                <div className="body">
                    {(() => {
                        if (this.state.loading) {
                            return <div className="loader"><Spinner animation="border" className="spinner"/></div>;
                        } else {
                            return (
                                <div className="directory-content">
                                    <div className="filters d-flex justify-content-center flex-wrap">
                                        {
                                            this.state.filters.map((filter, index) => (
                                                <button type="button" className="filter-option btn btn-link" key={`filter-${index}`} onClick={() => this.filterBy(filter)}>
                                                    {filter}
                                                </button>
                                            ))
                                        }
                                    </div>
                                        {_.isEmpty(this.state.filtered_directories) ? (
                                            <div className="empty-div">No Specialty</div>
                                        ) : (
                                            <div className="directory-items">
                                                {
                                                    this.state.filtered_directories.map((item, index) => (
                                                        <a href={`/../search-book/result?specialty=${encodeURIComponent(item.name)}&type=specialty`} className="item btn btn-link" key={`directory-item-${index}`}>
                                                            {item.name}
                                                        </a>
                                                    ))
                                                }
                                            </div>
                                        )}
                                </div>
                            );
                        }
                    })()}
                </div>
            </div>
            </>
        );
    }
}

export { Specialties };
